import React from 'react';
import { lineColors } from '../styles';
import { filterNulls, createDateArray } from '../../util/timeseries';

import Plotly from 'plotly.js-basic-dist';
// customizable method: use your own `Plotly` object
import createPlotlyComponent from 'react-plotly.js/factory';
const Plot = createPlotlyComponent(Plotly);


export function RegionChart(props) {
    let data = [];

    let yAxisTitle = '';
    if (props) {
        if (props.series) {
            let series = createPlotlyDataArray(props.series);
            if (props.regions && series.length > 0) {
                let regions = createPlotlyDataArrayFromRegion(props.regions, series[0].x);
                for (let i of regions){
                    data.push(i);
                }

            }
            for (let i of series) {
                data.push(i);
            }
            
            yAxisTitle = getTitle(props.series);
        }
    }
    

    const layout = {
        title: props.title,
        autosize: true,
        margin: {
            l:10,
            t:80,
            r:0,
            b:20
        },
        legend: {
            orientation:"h",
            x:0.1,
            y:-0.3
        },
        yaxis: {
            title: yAxisTitle,
        }
    };

    return (
        <Plot data={data} layout={layout} useResizeHandler={true} style={style} config={{displaylogo: false, modeBarButtonsToRemove:['sendDataToCloud'], responsive:true}}/>
    );
}


// use 100% styles when using responsive handler to fill in the parent element
const style = {
    width: "100%",
    height: "100%"
};

function createPlotlyDataArrayFromRegion(regions, dateArray) {
    let plotlyArray = [];
    
    // want the min to
    for (let index = 0; index < regions.length; index++) {
        const region = regions[index];
        let y = [];
        for (let i = 0; i < dateArray.length; i++) {
            y.push(region.max);
        }
        let plotlyObj = {
            x: dateArray,
            y: y,
            type: 'scatter',
            fill: region.fill,
            name: region.name,
            fillcolor : region.color,
            color: region.color,
            line : {
                color: region.color
            }
        };
        
        plotlyArray.push(plotlyObj);
    }
    
    return (plotlyArray);
}


export function createPlotlyDataArray(seriesArray) {
    let plotlyArray = [];
    if (!seriesArray || seriesArray.length === 0) {
        return plotlyArray;
    }

    // create a date array that can be shared with all series
    // since they all have the same length
    var dates = createDateArray(seriesArray[0]);

    for (let i = 0; i < seriesArray.length; i++) {
        let series = seriesArray[i];
        let color = lineColors[i % lineColors.length];
        let data = filterNulls(series.values);

        var plotlyObj = {
            x: dates,
            y: data,
            type: 'scatter',
            name: series.name,
            color: color,
            line : {
                color: color
            }
        };

        plotlyArray.push(plotlyObj);
    }

    return plotlyArray;
}

export function getTitle(series) {
    if (!series || series.length === 0) {
        return '';
    }

    // series might be unitless so handle the case by returning empty 
    const title = series[0].unit ? `${series[0].unit}` : '';
    if (series.length === 1) {
        return title;
    }

    const firstUnit = series[0].unit;
    
    for (let i = 1; i < series.length; i++) {
        if (series[i].unit !== firstUnit) {
            return '';
        }
    }
    
    return title
}

export function TimeseriesChart(props) {
    let data = {};

    let yAxisTitle = '';
    if (props && props.series) {
      data = createPlotlyDataArray(props.series);
      yAxisTitle = getTitle(props.series);
    }

    const layout = {
      title: props.title,
      autosize: true,
        legend: {
          orientation:"h",
            x:0.37,
            y:-0.3
        },
        margin: {
          l:props.margins.l,
            r:props.margins.r,
            t:props.margins.t,
            b:props.margins.b,
          pad: 0
        },
      yaxis: {
        title: yAxisTitle,
      }
    };

    return (
      <Plot data={data} layout={layout} useResizeHandler={true} style={style} config={{displaylogo: false, modeBarButtonsToRemove:['sendDataToCloud'], responsive:true}}/>
    );
}


// WEBPACK FOOTER //
// ./src/components/Charts/TimeseriesChart.jsx